import { PageFace } from "./PageFace";

export function SpreadPreview({ pages, book, copyright, aspect }) {
  const seq = [{ kind: "title" }, { kind: "copyright" }, ...pages.map((pg) => ({ kind: "image", pg }))];
  if (seq.length % 2) seq.push({ kind: "blank" });
  const spreads = [[null, seq[0]]];
  for (let i = 1; i < seq.length; i += 2) spreads.push([seq[i], seq[i + 1] || null]);
  const W = 230;
  return (
    <div className="space-y-6 overflow-x-auto" data-testid="spread-preview">
      {spreads.map((pair, s) => (
        <div key={s} className="flex flex-col items-center gap-1.5" data-testid={`spread-${s}`}>
          <div className="flex shadow-[0_8px_30px_rgba(0,0,0,0.5)]">
            {pair.map((f, j) => (f ? <PageFace key={j} kind={f.kind} pg={f.pg} book={book} copyright={copyright} width={W} aspect={aspect} testId={`spread-${s}-${j ? "right" : "left"}`} />
              : <div key={j} style={{ width: W }} />))}
          </div>
          <p className="text-[11px] font-mono text-slate-500">{s === 0 ? "p1" : `p${2 * s} – p${2 * s + 1}`}</p>
        </div>
      ))}
    </div>
  );
}
